import React, {useContext, useState} from 'react';
import { fetchSuggestions } from '../../http/bookAPI';
import Papa from 'papaparse';
import Loader from "../Loader";
import Row from "react-bootstrap/Row";
import {Button, Card, Col} from "react-bootstrap";
import {REGISTRATION_ROUTE} from "../../utils/consts";
import {Context} from "../../index";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";

const AmazonSuggestions = () => {
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [expanded, setExpanded] = useState({});
    const [subLoading, setSubLoading] = useState({}); // независимый лоадер
    const [where, setWhere] = useState('');
    const [useBefore, setUseBefore] = useState(false);
    const [useAfter, setUseAfter] = useState(false);

    const beforeKeywords = ['guide for', 'manual', 'how to', '2025']; // можешь задать любые
    const afterKeywords = ['for', 'and', 'with', 'bible', 'book', '2025'];   // можешь задать любые

    const [beforeSuggestions, setBeforeSuggestions] = useState([]);
    const [afterSuggestions, setAfterSuggestions] = useState([]);
    const { user } = useContext(Context);
    const navigate = useNavigate();
    const isMobile = window.innerWidth < 980; // или useMediaQuery

    const resetData = () => {
        setQuery('');
        setSuggestions([]);
        setLoading(false);
        setError(null);
        setExpanded({});
        setSubLoading({});
        setBeforeSuggestions([]);
        setAfterSuggestions([]);
    }


    const handleSearch = async () => {
        if (!query.trim()) return;

        setLoading(true);
        setError(null);
        setSuggestions([]);
        setExpanded({});
        setSubLoading({});
        setBeforeSuggestions([]);
        setAfterSuggestions([]);


        try {
            const data = await fetchSuggestions(query.trim(), where, '', '');
            setSuggestions(data.suggestions || []);
            // Если активен useBefore — запускаем все before запросы
            if (useBefore) {
                if (!user?.user?.id) {
                    toast.error("Sign Up Free to See Key Before!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    return;
                }
                const results = await Promise.all(
                    beforeKeywords.map(b =>
                        fetchSuggestions(`${b} ${query.trim()}`, where, '', '')
                            .then(res => res.suggestions || [])
                            .catch(() => [])
                    )
                );
                setBeforeSuggestions(results.flat());
            }

            // Если активен useAfter — запускаем все after запросы
            if (useAfter) {
                if (!user?.user?.id) {
                    toast.error("Sign Up Free to See Key After!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    return;
                }
                const results = await Promise.all(
                    afterKeywords.map(a =>
                        fetchSuggestions(`${query.trim()} ${a}`, where, '', '')
                            .then(res => res.suggestions || [])
                            .catch(() => [])
                    )
                );
                setAfterSuggestions(results.flat());
            }
        } catch (err) {
            console.error('Error fetching suggestions:', err);
            setError('Failed to fetch suggestions');
        } finally {
            setLoading(false);
        }
    };

    const handleSubSearch = async (keyword) => {
        if (expanded[keyword]) {
            setExpanded((prev) => {
                const newState = { ...prev };
                delete newState[keyword];
                return newState;
            });
            return;
        }
        if (!user?.user?.id) {
            toast.error("Sign Up Free to Search More!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        setSubLoading((prev) => ({ ...prev, [keyword]: true }));

        try {
            const data = await fetchSuggestions(keyword, where, '', '');
            setExpanded((prev) => ({
                ...prev,
                [keyword]: data.suggestions || []
            }));
        } catch (err) {
            console.error('Error fetching sub-suggestions:', err);
        } finally {
            setSubLoading((prev) => ({ ...prev, [keyword]: false }));
        }
    };

    const handleExportCSV = () => {
        const rows = [];

        // Основные подсказки
        suggestions.forEach((sugg) => {
            rows.push({ Level: 'Main', Parent: '', Suggestion: sugg });

            // Вложенные подсказки, если есть
            if (expanded[sugg]) {
                expanded[sugg].forEach((sub) => {
                    rows.push({ Level: 'Sub', Parent: sugg, Suggestion: sub });
                });
            }
        });

        // BEFORE подсказки
        beforeSuggestions.forEach((sugg) => {
            rows.push({ Level: 'Before', Parent: '', Suggestion: sugg });
        });

        // AFTER подсказки
        afterSuggestions.forEach((sugg) => {
            rows.push({ Level: 'After', Parent: '', Suggestion: sugg });
        });

        const csv = Papa.unparse(rows);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'amazon_virtalibry_suggestions.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Card className="p-1 w-100 mt-2">
        <div className="container mt-2">
            <h1 className="text-muted fs-5">Amazon Keyword Suggestions – Free Tool for Authors & Marketers-This tool is Closed</h1>
            <p className="text-muted small">
                Use our <strong>free Amazon Suggestion Extractor</strong> to instantly generate top search suggestions based on any keyword.
                This powerful tool lets you explore <strong>real-time search terms</strong> used by Amazon customers in the <strong>All, Books</strong> and <strong>Kindle</strong> categories.
            </p>
            <div className="p-3 shadow-sm rounded border bg-white mt-3">
                <div className="d-flex flex-wrap align-items-center gap-3">
                    {/* Search input and button */}
                    <div className="input-group" style={{ minWidth: '240px', maxWidth: '100%' }}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your query..."
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                        />
                        <button className="btn btn-success"
                                disabled={true}
                                onClick={handleSearch}>
                            Search
                        </button>
                    </div>

                    {/* Radio buttons */}
                    <div className="d-flex flex-wrap gap-2">
                        <div className="form-check me-2">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="whereOptions"
                                id="allOption"
                                value="all"
                                checked={where === ''}
                                onChange={() => setWhere('')}
                            />
                            <label className="form-check-label small" htmlFor="allOption">All</label>
                        </div>
                        <div className="form-check me-2">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="whereOptions"
                                id="booksOption"
                                value="stripbooks"
                                checked={where === 'stripbooks'}
                                onChange={() => setWhere('stripbooks')}
                            />
                            <label className="form-check-label small" htmlFor="booksOption">Books</label>
                        </div>
                        <div className="form-check me-2">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="whereOptions"
                                id="kindleOption"
                                value="digital-text"
                                checked={where === 'digital-text'}
                                onChange={() => setWhere('digital-text')}
                            />
                            <label className="form-check-label small" htmlFor="kindleOption">Kindle</label>
                        </div>
                    </div>

                    {/* Switches */}
                    <div className="d-flex flex-wrap gap-2 align-items-center">
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="switchBefore"
                                checked={useBefore}
                                onChange={() => setUseBefore(!useBefore)}
                            />
                            <label className="form-check-label small" htmlFor="switchBefore">Before</label>
                        </div>
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="switchAfter"
                                checked={useAfter}
                                onChange={() => setUseAfter(!useAfter)}
                            />
                            <label className="form-check-label small" htmlFor="switchAfter">After</label>
                        </div>
                    </div>

                    {/* Clear button */}
                    <div>
                        <Button
                            variant="outline-success"
                            size="sm"
                            onClick={resetData}
                        >
                            Clear
                        </Button>
                    </div>
                </div>
            </div>

            {suggestions.length > 0 && (
                <div className="p-3 shadow-sm rounded border bg-white mt-4">
                    <h5 className="text-muted fst-italic mb-3">
                        Suggestions we found for Keyword "{query}"
                    </h5>

                    {/* 📱 Адаптивный контейнер */}
                    <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '8px' }}>
                        <table className="table table-sm table-striped" style={{ minWidth: '600px' }}>
                            <thead>
                            <tr>
                                <th className="align-middle fst-italic text-muted" style={{ width: '3%' }}>#</th>
                                <th className="align-middle text-start fst-italic text-muted">Main Suggestion:</th>
                                <th className="align-middle text-end fst-italic text-muted">Actions:</th>
                            </tr>
                            </thead>
                            <tbody>
                            {suggestions.map((s, i) => (
                                <React.Fragment key={i}>
                                    <tr style={{ height: '24px' }}>
                                        <td className="align-middle fst-italic small fw-bolder text-muted">{i + 1}</td>
                                        <td className="align-middle text-start fst-italic small fw-bolder text-muted">{s}</td>
                                        <td className="align-middle text-end">
                                            <button
                                                className="btn btn-outline-secondary btn-sm"
                                                onClick={() => handleSubSearch(s)}
                                                disabled={subLoading[s]}
                                            >
                                                {subLoading[s]
                                                    ? 'Loading...'
                                                    : Array.isArray(expanded[s])
                                                        ? (expanded[s].length === 0 ? 'Nothing Found' : 'Hide')
                                                        : 'Search More'}
                                            </button>
                                        </td>
                                    </tr>

                                    {/* Sub-suggestions */}
                                    {expanded[s] && (
                                        <tr>
                                            <td></td>
                                            <td colSpan="3" className="p-0">
                                                <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                                                    <table className="table table-sm table-bordered mb-0" style={{ minWidth: '400px' }}>
                                                        <thead>
                                                        <tr>
                                                            <th className="align-middle small fst-italic text-muted" style={{ width: '3%' }}>#</th>
                                                            <th className="align-middle text-start small fst-italic text-muted">Sub Suggestion:</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {expanded[s].map((sub, j) => (
                                                            <tr key={j} style={{ height: '24px' }}>
                                                                <td className="align-middle fst-italic small text-muted">{j + 1}</td>
                                                                <td className="align-middle text-start small fst-italic text-muted">{sub}</td>
                                                            </tr>
                                                        ))}
                                                        {expanded[s].length === 0 && (
                                                            <tr>
                                                                <td colSpan="2" className="text-center text-muted">
                                                                    No sub-suggestions found
                                                                </td>
                                                            </tr>
                                                        )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}


            {suggestions.length > 0 && !user?.user?.id && (
                <Row className="text-center mb-3">
                    <Col>

                        <Button
                            variant="success"
                            size="lg"
                            className="shadow-sm mt-4 mb-1"
                            style={{ borderRadius: '5px' }}
                            onClick={() => navigate(REGISTRATION_ROUTE)}
                        >
                            🔗 Join for Free to Unlock Full Details
                        </Button>

                    </Col>
                </Row>
            )}

            {/* BEFORE TABLE */}
            {beforeSuggestions.length > 0 && (
                <div className="mt-4">
                    <div className="p-3 shadow-sm rounded border bg-white">
                    <h6 className="text-muted fst-italic">Suggestions with "Before" Keywords</h6>
                    <table className="table table-sm table-striped">
                        <thead>
                        <tr>
                            <th className="fst-italic small text-muted" style={{ width: '3%' }}>#</th>
                            <th className="fst-italic small text-muted">Suggestion</th>
                        </tr>
                        </thead>
                        <tbody>
                        {beforeSuggestions.map((s, i) => (
                            <tr key={`before-${i}`}>
                                <td className="text-muted small">{i + 1}</td>
                                <td className="text-muted small">{s}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                </div>
            )}

            {/* AFTER TABLE */}
            {afterSuggestions.length > 0 && (
                <div className="mt-4">
                    <div className="p-3 shadow-sm rounded border bg-white">
                    <h6 className="text-muted fst-italic">Suggestions with "After" Keywords</h6>


                        <table
                            className="table table-sm table-striped mb-0"
                            style={{ borderRadius: '0.5rem', overflow: 'hidden' }}
                        >
                            <thead>
                            <tr>
                                <th className="fst-italic small text-muted" style={{ width: '3%' }}>#</th>
                                <th className="fst-italic small text-muted">Suggestion</th>
                            </tr>
                            </thead>
                            <tbody>
                            {afterSuggestions.map((s, i) => (
                                <tr key={`after-${i}`}>
                                    <td className="text-muted small">{i + 1}</td>
                                    <td className="text-muted small">{s}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}


            {loading && <Loader />}
            {error && <div className="text-danger mb-3">{error}</div>}
            <button
                className="btn btn-success btn-sm mt-3 mb-2"
                onClick={handleExportCSV}
                disabled={suggestions.length === 0}
            >
                Download CSV File
            </button>
            <div className="text-muted small">


                <p>
                    Dig deeper into related keywords with just one click and easily <strong>download all results</strong> in a clean, structured CSV file.
                </p>

                {!user?.user?.id && (
                    <>
                <p>
                    For advanced features — like extended keyword ideas using <em>“Before”</em> and <em>“After”</em> terms (e.g. <code>guide for X</code> or <code>X for beginners</code>) — simply register for free.
                    <br />
                    <small className="text-secondary">*No credit card needed.</small>
                </p>

                        <h6>Once signed up, you’ll unlock:</h6>
                        <ul>
                            <li>Deeper, multi-level keyword suggestions</li>
                            <li>Downloadable CSV export</li>
                            <li>Sub-suggestions for every result</li>
                            <li>Access to more keyword variations</li>
                        </ul>
                    </>
                )}



                <p>
                    <strong>Ideal for</strong> self-publishers, marketers, and authors looking to:
                </p>
                <ul>
                    <li>Optimize book listings on Amazon</li>
                    <li>Discover niche content opportunities</li>
                    <li>Research KDP trends with precision</li>
                </ul>
                {!user?.user?.id && (
                    <>
                <p>
                    <strong>Try it now — full access is just one free sign-up away!</strong>
                </p>

                    </>
                )}
            </div>


        </div>
        </Card>
    );
};

export default AmazonSuggestions;
